import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui

import {
  FormControl,
  InputLabel,
  Input,
  Paper,
  Dialog,
  DialogTitle,
  TextField,
} from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import Rating from '@mui/material/Rating';

import Swal from 'sweetalert2';
import { useRouter } from 'src/routes/hooks';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import Button from '@mui/material/Button';

import Iconify from 'src/components/iconify';

// import '../../../style.css';
import httpCommon from 'src/http-common';
import { RxCrossCircled } from 'react-icons/rx';
import { border } from '@mui/system';
import LoderImg from './Spain_loderImg.gif';

// ----------------------------------------------------------------------

export default function CompleteStatus({ selectedRowID, closeModalComplete }) {
  const router = useRouter();

  const getId = localStorage.getItem('ww_emp_mst_empl_id');
  const getHsp = localStorage.getItem('ww_Hsp'); // site_cd

  const SelectedUserId = selectedRowID; // UserId
  const [loading, setLoading] = useState(false);
  const [UserDt, setUserDt] = useState([]);

  const [UserDtImg, setUserDtImg] = useState([]);

  const [UserInfoData, setUserInfoData] = useState([]);
  const [phnNo, setPhnNo] = useState('');
  const Username = UserInfoData?.wkr_mst_requestor || '';
  const userdept = UserInfoData?.wkr_mst_dept || '';
  const [ratingValue, setRatingValue] = useState(2);
  const [textareaValue, setTextareaValue] = useState('');
  const [imageDialog, setImageDialog] = useState(false);
  const [imageData, setImageData] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const url = httpCommon.defaults.baseURL;
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [department, setDepartment] = useState('');
  const [empl,setEmpl] = useState("")
  const [FilledFormData, setFilledFormData] = useState({
    workArea: '',
    level: '',
    assetLocation: '',
    assetNumber: '',
    workGroup: '',
    originalProperty: '',
    faultyCode: '',
    workDescription: '',
    workOrderNo: '',
    completedBy: '',
    workCorrective: '',
  });

  // Get Api All Data
  useEffect(() => {
    const fetchUserWorkListData = async () => {
      setLoading(true);
      try {
        const response = await httpCommon.get(
          `/CompleteStatus.php?id=${getId}&siteCd=${getHsp}&UserId=${SelectedUserId}`
        );

        console.log('ratinfgData', response);

        setFilledFormData((pre) => ({
          ...pre,
          image: response.data.data1.attachment,
          filename: response.data.data1.attachment,
        }));

        if (response.data.status === 'SUCCESS') {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          setUserDt(response.data.data1);
          setUserDtImg(response.data.data1[1]);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserWorkListData(); // Call the function directly
  }, [getId, getHsp, SelectedUserId]);
  // Fetch user Form Data Request
  useEffect(() => {
    setLoading(true);
    const fetchUserRequest = async () => {
      console.log('selectedId', SelectedUserId);
      try {
        const response = await httpCommon.get(
          `/AllFormDataGet.php?siteCd=${getHsp}&UserId=${SelectedUserId}`
        );

        if (response.data.status === 'SUCCESS') {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          // If you want to call setFilledFormData here, uncomment the following lines
          setFilledFormData((prev) => {
            const data = response.data.data1 && response.data.data1[0];

            return {
              ...prev,
              workArea:
                data && data.wkr_mst_work_area && data.work_area_desc
                  ? `${data.wkr_mst_work_area} : ${data.work_area_desc}`
                  : ' ',
              level:
                data && data.wkr_mst_location && data.wkr_mst_location_desc
                  ? `${data.wkr_mst_location} : ${data.wkr_mst_location_desc}`
                  : ' ',
              assetLocation:
                data && data.wkr_mst_assetlocn && data.wkr_mst_assrtlocn_desc
                  ? `${data.wkr_mst_assetlocn} : ${data.wkr_mst_assrtlocn_desc}`
                  : ' ',
              assetNumber:
                data && data.wkr_mst_assetno && data.wkr_mst_assetno_desc
                  ? `${data.wkr_mst_assetno} : ${data.wkr_mst_assetno_desc}`
                  : ' ',
              workGroup:
                data && data.wkr_mst_work_group && data.work_group_desc
                  ? `${data.wkr_mst_work_group} : ${data.work_group_desc}`
                  : ' ',
              originalProperty:
                data && data.wkr_mst_orig_priority && data.orig_priority_desc
                  ? `${data.wkr_mst_orig_priority} : ${data.orig_priority_desc}`
                  : ' ',
              faultyCode:
                data && data.wkr_mst_fault_code && data.fault_code_desc
                  ? `${data.wkr_mst_fault_code} : ${data.fault_code_desc}`
                  : ' ',
              workDescription: data && data.wkr_mst_wr_descs ? data.wkr_mst_wr_descs : ' ',
            };
          });
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserRequest(); // Call the fetchUserRequest function here
  }, [getHsp, SelectedUserId]);

  // get UserInformation
  useEffect(() => {
    setLoading(true);
    const fetchUserInfo = async () => {
      const requestData = {
        site_cd: getHsp,
        login_id: getId,
        mst_rowID: selectedRowID,
      };

      try {
        const response = await httpCommon.post('/GetUserInfo.php', requestData);

        if (response.data.status === 'SUCCESS') {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          setName(response.data.data.query1_response[0].emp_mst_name);

          setDepartment(response.data.data.query1_response[0].emp_det_department);
          setEmpl(response.data.data.query1_response[0].emp_mst_empl_id)
          setPhnNo(response.data.data.query1_response[0].emp_mst_homephone);
          setEmail(response.data.data.query1_response[0].emp_det_email_id
          );
        }
      } catch (error) {
        console.log('Error', error);
      }
    };
    fetchUserInfo();
  }, [getHsp, getId, selectedRowID]);
  // chdck setting mode
  useEffect(() => {
    document.body.classList.remove('customNav');
    const handleThemeOnLoad = () => {
      const storedValue = localStorage.getItem('dataDark');
      if (storedValue === 'dark') {
        document.body.classList.add('custom-darkClass');
      } else {
        document.body.classList.remove('custom-darkClass');
      }
    };
    handleThemeOnLoad();
    return () => {
      document.body.classList.remove('custom-darkClass');
    };
  }, []);
  const handleImageDialog = (ImageUrl, title) => {
    const newStr = title?.replace('upload//', '');
    setImageData((pre) => ({ ImageUrl, head: newStr }));
    setImageDialog(true);
  };
  useEffect(() => {
    setLoading(true);
    const fetchuserInfo = async () => {
      const requestData = {
        site_cd: getHsp,
        login_id: getId,
      };
      try {
        const response = await httpCommon.post('/getUserWRInfo.php', requestData);

        if (response.data.status === 'SUCCESS') {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          setUserInfoData(response.data.data[0]);
          setPhnNo(response.data.data[0].wkr_mst_phone);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // Call the fetchuserInfo function when the component mounts.
    fetchuserInfo();
  }, [getHsp, getId, SelectedUserId]);

  const selectedSchema = '';

  const methods = useForm({
    resolver: yupResolver(selectedSchema),
  });
  // console.log("SelectedUserId__",SelectedUserId);
  const formatDate = (dateString) => {
    const rawDate = new Date(dateString);
    const day = String(rawDate.getDate()).padStart(2, '0');
    const month = String(rawDate.getMonth() + 1).padStart(2, '0');
    const year = rawDate.getFullYear();
    const hours = String(rawDate.getHours()).padStart(2, '0');
    const minutes = String(rawDate.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const handleRatingChange = (event, newValue) => {
    setRatingValue(newValue); // Update the state with the new rating value
  };
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <>
      {' '}
      <Dialog
        open={loading}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={LoderImg} alt="loderImg" style={{ width: '80px' }} />
        </div>
      </Dialog>
      <FormProvider methods={methods}>
        <Grid container spacing={4} className="RejectStatusCs">
          <Grid xs={12} md={5}>
            <Card sx={{ px: 3, pb: 5 }}>
              <Typography
                variant="subtitle2"
                sx={{ mb: 3, mt: 2 }}
                className="flex items-center gap-2"
              >
                <Iconify
                  icon="codicon:git-pull-request-new-changes"
                  style={{ marginBottom: '-5px' }}
                />{' '}
                Requester Information
              </Typography>

              <Box display="flex" flexDirection="column" rowGap={3}>
                {/* <TextField id="filled-basic" label="Employee ID"  inputProps={{ className: 'RejinputClass' }} disabled variant="filled"  defaultValue={getId} /> */}

                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Employee ID</InputLabel>
                    <Input type="text" name="name" value={empl} disabled />
                  </FormControl>
                </div>
                <div>
                  {(() => {
                    if (name) {
                      return (
                        <div className="usrFrmFld">
                          <FormControl>
                            <InputLabel>Name</InputLabel>
                            <Input type="text" name="contactNo" disabled defaultValue={name} />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <RHFTextField
                          id="outlined-basic"
                          name="contactNo"
                          label="Contact No"
                          variant="filled"
                          value="  "
                          disabled
                        />
                      </div>
                    );
                  })()}
                </div>
                <div>
                  {(() => {
                    if (department) {
                      return (
                        <div className="usrFrmFld">
                          <FormControl>
                            <InputLabel>Department</InputLabel>
                            <Input
                              type="text"
                              name="department"
                              defaultValue={department || ''}
                              disabled
                            />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <RHFTextField
                          id="outlined-basic"
                          name="department"
                          label="Department"
                          variant="filled"
                          value="  "
                          disabled
                        />
                      </div>
                    );
                  })()}
                </div>
                <div>
                  {(() => {
                    if (phnNo) {
                      return (
                        <div className="usrFrmFld">
                          <FormControl>
                            <InputLabel>Contact No</InputLabel>
                            <Input
                              type="text"
                              name="contactNo"
                              defaultValue={phnNo || ''}
                              disabled
                            />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <RHFTextField
                          id="outlined-basic"
                          name="contactNo"
                          label="Contact No"
                          variant="filled"
                          value="  "
                          disabled
                        />
                      </div>
                    );
                  })()}
                </div>
                {/* email */}
                <div>
                  {(() => {
                    if (email) {
                      return (
                        <div className="usrFrmFld">
                          <FormControl>
                            <InputLabel>Email</InputLabel>
                            <Input type="text" name="email" defaultValue={email || ''} disabled />
                          </FormControl>
                        </div>
                      );
                    }
                    return (
                      <div className="fuWdt">
                        <RHFTextField
                          id="outlined-basic"
                          name="email"
                          label="Email"
                          variant="filled"
                          value="  "
                          disabled
                        />
                      </div>
                    );
                  })()}
                </div>
              </Box>
            </Card>
          </Grid>

          <Grid xs={12} md={7}>
            <Card sx={{ px: 3, pb: 5 }}>
              <Typography
                variant="subtitle2"
                sx={{ mb: 3, mt: 2 }}
                className="flex items-center gap-2"
              >
                <Iconify icon="grommet-icons:workshop" style={{ marginBottom: '-5px' }} /> Work
                Request Information
              </Typography>

              <Box display="flex" flexDirection="column" rowGap={3}>
                <RHFTextField
                  name="requestDate"
                  variant="filled"
                  label="Request Date"
                  disabled
                  inputProps={{ className: 'RejinputClass' }}
                  // value={UserDt[0]?.wkr_mst_org_date.date.split(' ')[0]}
                  // value={formatDate(UserDt[0]?.wkr_mst_org_date.date)}
                  value={
                    UserDt[0]?.wkr_mst_org_date.date
                      ? formatDate(UserDt[0]?.wkr_mst_org_date.date)
                      : ''
                  }
                />

                {/* work area */}
                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Work Area</InputLabel>
                    <Input type="text" value={FilledFormData?.workArea} disabled />
                  </FormControl>
                </div>
                {/* level */}
                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Level</InputLabel>
                    <Input
                      type="text"
                      name="wkr_mst_location"
                      value={FilledFormData?.level}
                      disabled
                    />
                  </FormControl>
                </div>

                {/* Asset Location */}
                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Asset Location</InputLabel>
                    <Input
                      type="text"
                      disabled
                      name="wkr_mst_assetlocn"
                      value={FilledFormData?.assetLocation}
                    />
                  </FormControl>
                </div>
                {/* Asset Number */}
                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Asset Number</InputLabel>
                    <Input
                      type="text"
                      name="wkr_mst_assetno"
                      value={FilledFormData?.assetNumber}
                      disabled
                    />
                  </FormControl>
                </div>
                {/* work group */}
                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Work Group</InputLabel>
                    <Input
                      type="text"
                      name="wkr_mst_work_group"
                      value={FilledFormData?.workGroup}
                      disabled
                    />
                  </FormControl>
                </div>
                {/* Original Property */}

                {/* Faulty Code */}
                <div className="usrFrmFld">
                  <FormControl>
                    <InputLabel>Fault Code</InputLabel>
                    <Input
                      type="text"
                      name="wkr_mst_fault_code"
                      value={FilledFormData?.faultyCode}
                      disabled
                    />
                  </FormControl>
                </div>

                <div
                  className="border border-black rounded-lg bg-[#edeff1] text-black"
                  style={{ padding: '4px 16px' }}
                >
                  <InputLabel style={{ color: 'black', fontSize: '13px', fontWeight: '500' }}>
                    Request Description
                  </InputLabel>
                  <textarea
                    rows={4}
                    className="bg-[#edeff1] text-[14px] w-full"
                    value={FilledFormData.workDescription}
                    disabled
                  />
                </div>

                {/* Create Image grid */}
                <Grid container>
                  {UserDt &&
                    !imageError &&
                    UserDt.map((item) => (
                      <Grid
                        item
                        xs={3}
                        onClick={() =>
                          handleImageDialog(`${url}/${item.attachment}`, item?.file_name)
                        }
                      >
                        <Paper
                          elevation={3}
                          style={{ padding: 10, textAlign: 'center', height: 100, width: 100 }}
                        >
                          <img
                            src={`${url}/${item.attachment}`}
                            alt="yes"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            onError={handleImageError}
                          />
                        </Paper>
                      </Grid>
                    ))}
                </Grid>
              </Box>
            </Card>
            <Card sx={{ px: 3, pb: 5 }} className="RejInfo ">
              <Typography
                variant="subtitle2"
                sx={{ mb: 3, mt: 2 }}
                className="flex items-center gap-2"
              >
                <Iconify icon="lets-icons:done-ring-round" style={{ marginBottom: '-5px' }} />{' '}
                Complete Information
              </Typography>
              <Box display="flex" flexDirection="column" rowGap={3}>
                <RHFTextField
                  name="Order Number"
                  variant="filled"
                  label="Work Order Number"
                  disabled
                  inputProps={{ className: 'RejinputClass' }}
                  value={UserDt[0]?.wko_mst_wo_no || ' '}
                />

                <RHFTextField
                  name="Comptby"
                  variant="filled"
                  label="Complete By"
                  disabled
                  inputProps={{ className: 'RejinputClass' }}
                  value={UserDt[0]?.wko_sts_audit || ' '}
                />

                {/* <div className="disableBlack">
                      <RHFTextField
                       name="workcorr"
                       variant="filled"
                       label="Corrective Action "
                       className="wkoDetCorr"
                        multiline
                        rows={4}
                        disabled
                        value={UserDt[0]?.wko_det_corr_action || ' '}

                      />
                    </div> */}

                <div
                  className="border border-black rounded-lg bg-[#edeff1] text-black"
                  style={{ padding: '4px 16px' }}
                >
                  <InputLabel style={{ color: 'black', fontSize: '13px', fontWeight: '500' }}>
                    Corrective Action
                  </InputLabel>
                  <textarea
                    rows={4}
                    className="bg-[#edeff1] text-[14px] w-full"
                    value={UserDt[0]?.wko_det_corr_action || ' '}
                    disabled
                  />
                </div>
              </Box>
            </Card>

            <Card sx={{ px: 3, pb: 5 }} className="RejInfo">
              <Typography
                variant="subtitle2"
                sx={{ mb: 3, mt: 2 }}
                className="flex items-center gap-2"
              >
                <Iconify
                  icon="streamline:interface-favorite-like-1-reward-social-up-rating-media-like-thumb-hand"
                  style={{ marginBottom: '-5px' }}
                />{' '}
                Rating Information
              </Typography>
              <Box>
                <div className="RtingMain">
                  <div className="RatingCls">
                    <Rating
                      name="size-large"
                      value={parseFloat(UserDt[0]?.ratingCMP).toString()}
                      size="large"
                      readOnly
                      onChange={handleRatingChange}
                      className="no-hover-effect"
                    />

                    <div
                      className="border border-black rounded-lg bg-[#edeff1] text-black"
                      style={{ padding: '4px 16px' }}
                    >
                      <InputLabel style={{ color: 'black', fontSize: '13px', fontWeight: '500' }}>
                      Rating
                      </InputLabel>
                      <textarea
                        rows={4}
                        className="bg-[#edeff1] text-[14px] w-full"
                        value={UserDt[0]?.ratingDtCMP}
                        disabled
                      />
                    </div>

                    {/* <div className="disableBlack">
                      <RHFTextField
                        name="reqDescrriptin"
                        variant="filled"
                        label="Rating"
                        multiline
                        rows={4}
                        disabled
                        value={UserDt[0]?.ratingDtCMP}
                      />
                    </div> */}
                 
                  </div>
                </div>
              </Box>
            </Card>
          </Grid>
        </Grid>

        {/* Dialog Image */}
        <Dialog
          open={imageDialog}
          onClose={() => setImageDialog(false)}
          fullWidth
          maxWidth="xs" // Adjust the maximum width for smaller screens
          PaperProps={{
            style: {
              maxHeight: '90vh', // Set maximum height to 80% of the viewport height
              overflowY: 'auto', // Enable vertical scrolling if content exceeds maxHeight
              padding: '20px',
            },
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0 10px 0 10px',
            }}
          >
            <div
              style={{
                alignItems: 'center',
                gap: '2px',
                // Conditionally hide on small screens
                display: 'flex', // Initially hide
              }}
            >
              <DialogTitle id="alert-dialog-title" className="title">
                {imageData.head}
              </DialogTitle>
            </div>
            <RxCrossCircled
              size={28}
              style={{ color: 'red', cursor: 'pointer' }}
              onClick={() => setImageDialog(false)}
            />
          </div>
          <div style={{ flex: 1, overflow: 'hidden' }}>
            {/* Ensure proper filling */}
            <div
              style={{
                height: '50vh', // Subtract the height of the dialog header
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                src={imageData.ImageUrl}
                alt="imagePending"
                style={{ maxWidth: '100%', height: 'auto', objectFit: 'cover' }}
              />
            </div>
          </div>
        </Dialog>
      </FormProvider>
    </>
  );
}

CompleteStatus.propTypes = {
  selectedRowID: PropTypes.object,
  closeModalComplete: PropTypes.object,
};
